

export const getWidthDefinition = (width: number | null | undefined, default_width: number) => {
  const md_to_xs = (md: number) => {
    //calculate reasonable xs size from md size
    if(md <= 3) return 6
    return 12
  }

  let md = default_width;
  if(width !== null && width !== undefined) md = width;
  if(md < 1) md = 1
  if(md > 12) md = 12
  const xs = md_to_xs(md)

  return {md: md,
          xs: xs}

}
